export const VIDEO_WIDTH = 1920
export const VIDEO_HEIGHT = 1080
export const VIDEO_RATIO = VIDEO_WIDTH / VIDEO_HEIGHT
